import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { SaleEntryDialogComponent } from '../../dialogs/sale-entry-dialog/sale-entry-dialog.component';
import { CURRENT_USER } from '../../../shared/tokens/current-user';
import { User } from '../../../shared/interfaces/user';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-home',
    standalone: true,
    imports: [CommonModule, MatButtonModule, RouterLink],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
})
export class HomeComponent {
    public readonly year = new Date().getFullYear();

    public constructor(
        @Inject(CURRENT_USER) protected readonly user: User,
        private readonly dialog: MatDialog,
    ) {
        //
    }

    public onSaleEntry(): void {
        this.dialog.open(SaleEntryDialogComponent, {
            width: '500px',
        });
    }
}
